// extracted by mini-css-extract-plugin
module.exports = {"typeIcon":"CatalogIcon_typeIcon__3AIBf","shopifyIcon":"CatalogIcon_shopifyIcon__lw_RE","customIcon":"CatalogIcon_customIcon__2L0Q2"};